import { object, string } from "yup";

export const trackOrderValidation = (t) =>
  object().shape({
    email: string().required(t('emailIsRequired')).email(t('emailError')),
    order_number: string().required(t("OrderNumberRequired")),
  });
